module.exports = __webpack_public_path__ + "media/images/emblems/Blason_de_Cheyres-Chables-964fc62ff58a6c0e87f9bb243702f217.svg";